import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PropagateLoader } from 'react-spinners';
import { useAuth } from '../context/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(username, password);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div id="login-screen">
      <div className="lw">
        <div className="ll">
          <div className="l-emblem">
            <div className="l-badge-box"><i className="fa-solid fa-compass" /></div>
            <div>
              <div className="l-brand">TMIS</div>
              <div className="l-sub">TOURISM MANAGEMENT INSTITUTE OF SINGAPORE</div>
            </div>
          </div>
          <div className="l-head">Course Deployment<br /><em>Portal</em></div>
          <div className="l-desc">Plan, schedule and deploy TMIS's full range of tourism and hospitality programmes — from STB-licensed tourist guiding certificates to Master's degrees — with AI-assisted scheduling and agentic workflow intelligence.</div>
          <div className="l-badges">
            <div className="l-badge-pill"><i className="fa-solid fa-shield-check" /> EduTrust Aligned</div>
            <div className="l-badge-pill"><i className="fa-solid fa-graduation-cap" /> SkillsFuture SWDA</div>
            <div className="l-badge-pill"><i className="fa-solid fa-robot" /> Agentic AI Workflow</div>
            <div className="l-badge-pill"><i className="fa-solid fa-compass" /> STB Licensed</div>
          </div>
          <div className="l-prog-pills">
            <span className="l-prog-pill"><i className="fa-solid fa-compass" /> Tourist Guiding</span>
            <span className="l-prog-pill"><i className="fa-solid fa-clipboard-list" /> Short Courses</span>
            <span className="l-prog-pill"><i className="fa-solid fa-scroll" /> Diploma</span>
            <span className="l-prog-pill"><i className="fa-solid fa-graduation-cap" /> Bachelor Degree</span>
            <span className="l-prog-pill"><i className="fa-solid fa-hat-wizard" /> Master's Degree</span>
            <span className="l-prog-pill"><i className="fa-solid fa-robot" /> AI in Tourism</span>
            <span className="l-prog-pill"><i className="fa-solid fa-share-nodes" /> Social Media</span>
          </div>
        </div>
        <div className="lr">
          <form className="lc" onSubmit={handleSubmit}>
            <div className="lc-title">Welcome back</div>
            <div className="lc-sub">Sign in to TMIS Course Deployment Portal</div>
            {error && <div className="lc-err">{error}</div>}
            <div className="ff">
              <label htmlFor="login-username">Username</label>
              <input id="login-username" className="fi" type="text" placeholder="your.username" value={username} onChange={(e) => setUsername(e.target.value)} required autoComplete="username" />
            </div>
            <div className="ff">
              <label htmlFor="login-password">Password</label>
              <input id="login-password" className="fi" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required autoComplete="current-password" />
            </div>
            <button type="submit" className="btn-login" disabled={submitting}>
              {submitting ? (
                <PropagateLoader color="#fff" size={8} speedMultiplier={1} />
              ) : (
                <>
                  <i className="fa-solid fa-arrow-right-to-bracket" style={{paddingRight: '5px'}}/> Sign in to Portal
                </>
              )}
            </button>
            <div className="lc-foot"> <button type="button" className="lc-foot-link">Forgot password?</button></div>
          </form>
        </div>
      </div>
    </div>
  );
}
